export default {
    name: 'card-tooltip',
    props: {
        content: {
            default: ''
        },
        contentCustomr: {
            default: null
        }
    },
    render(h) {
        const { content, contentCustomr, $dataCheck, $t } = this
        return <span>
            {content.length ?
                <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                        <div >{content}</div>
                    </div>
                    <i class="icon-a-01wenhao iconfont-el icon"></i>
                </el-tooltip> : ''
            }
            {contentCustomr &&
                <el-tooltip class="item" effect="dark" placement="top-start">
                    <div slot="content">
                        <div >{contentCustomr(h)}</div>
                    </div>
                    <i class="icon-a-01wenhao iconfont-el icon"></i>
                </el-tooltip>
            }
        </span>
    }
}
